module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af064208b0423eea068b4aa07d183364.png";